// 中身の小さな道具（el・keyOf）。画面（page.php の要素）には触らない（2026-10-23 に util.ts から分けた）
import { NS } from '../config.js';
import type { Category } from '../types.js';

export function el<T extends SVGElement = SVGElement>(tag: string, attrs?: Record<string, string | number>): T {
  const node = document.createElementNS(NS, tag) as T;
  for (var k in attrs || {}) node.setAttribute(k, attrs![k]);
  return node;
}
export function keyOf(cat: Category): string { return cat.ALIAS || cat.NAME; }
